import { useApiRequest } from '@/lib/http-utils'
import { useQuery } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'
import { WorkflowStatus } from './use-all-workflows-query'

type UseScheduleWorkflowsQueryOptions = {
  scheduleId: string
}

type ScheduleWorkflow = {
  workflow_id: string
  schedule_id: string
  status: WorkflowStatus
  title: string
  last_update_time: number
}

type ScheduleWorkflowsResponse = {
  items: ScheduleWorkflow[]
  total: number
  page: number
  size: number
  pages: number
}

export function useScheduleWorkflowsQuery({ scheduleId }: UseScheduleWorkflowsQueryOptions) {
  const { apiRequest, domainId } = useApiRequest()

  return useQuery({
    queryKey: ['schedule-workflows', scheduleId, domainId],
    queryFn: async () => {
      const response = await apiRequest({
        path: taskManagerApiPaths.getScheduleWorkflows({ domainId, scheduleId }),
      })

      if (!response.ok) {
        throw new Error('FAILED_TO_FETCH_SCHEDULE_WORKFLOWS')
      }

      const data = (await response.json()) as ScheduleWorkflowsResponse
      return data
    },
  })
}
